export const ApplicationStatuses = {
  APPROVED: 'approved',
  PENDING: 'pending',
  REJECTED: 'rejected',
  MANUAL_APPROVAL: 'manualApproval',
} as const;
